import { Tags } from 'rbh-merchant-core';
import { CAT_STATE_KEY, CatState } from './cat-reducer';

export enum CAT_ACTION_TYPE {
  SET_CAT_STATE = 'SET_CAT_STATE',
  CALL_FOOD_CATEGORY = 'CALL_FOOD_CATEGORY',
}

export type SetCatStateAction<KeyName extends keyof CatState> = {
  type: CAT_ACTION_TYPE.SET_CAT_STATE;
  payload: { key: KeyName, value: CatState[KeyName] };
};

export type CallFoodCategoryAction = {
  type: CAT_ACTION_TYPE.CALL_FOOD_CATEGORY;
  payload: { onFailureCallback: () => void, isAddCategoryPage: boolean, onSuccessCallback?: (tagMaster: Tags[]) => void };
};


export type CatActions = SetCatStateAction<CAT_STATE_KEY> | CallFoodCategoryAction;
